import axios from "axios";

export const state = {
    testresults: [],
};

export const getters = {
    testresults: state => state.testresults,
};

export const mutations = {
    setResults(testresults, newValue) { state.testresults = newValue},
};

export const actions = {
    fetchTestResults({ commit }) {
        axios.get('/testresults').then(res => {
            commit('setResults', res.data.testresults)
        })
    },
};
